export default __webpack_public_path__ + "static/logo-a176addafa28be721f419a15efc58041.svg";